// 动态rem单位值
;(function () {
  // eslint-disable-next-line one-var
  let rem
  let dpr
  let time
  let doc = window.document
  let docEl = doc.documentElement
  let viewport = doc.querySelector('meta[name="viewport"]')
  let zoomScale
  let zoomScaleNum

  if (viewport) {
    zoomScale = viewport
      .getAttribute('content')
      // eslint-disable-next-line no-useless-escape
      .match(/initial\ -scale=(["']?)([\d\.]+)\1?/)
    if (zoomScale) {
      zoomScaleNum = parseFloat(zoomScale[2])
      dpr = parseInt(1 / zoomScaleNum)
    }
  }
  if (!dpr && !zoomScaleNum) {
    // eslint-disable-next-line one-var
    let os = window.navigator.appVersion.match(/iphone/gi)
    // eslint-disable-next-line no-redeclare
    dpr = window.devicePixelRatio
    dpr = os ? (dpr >= 3 ? 3 : dpr >= 2 ? 2 : 1) : 1
    zoomScaleNum = 1 / dpr
  }
  window.addEventListener(
    'resize',
    function () {
      clearTimeout(time)
      time = setTimeout(changeRem, 300)
    },
    false
  )

  // 改变基准rem
  function changeRem() {
    // 获取系统字体放大比例
    var fz = 20
    docEl.style.fontSize = fz + 'px'
    var realfz = +window.getComputedStyle(document.getElementsByTagName('html')[0]).fontSize.replace('px', '')
    var ratio = fz / realfz

    var docWidth = docEl.getBoundingClientRect().width

    // 判断屏幕宽度是否大于或等于768px
    if (docWidth >= 768) {
      // 不执行改变rem的逻辑，允许PC端使用固定的px单位
      return
    }

    if (docWidth / dpr > 540) {
      docWidth = 540 * dpr
    }
    // rem字号以320下的1rem=20px为基线进行等比缩放
    rem = (docWidth / 375) * 20
    docEl.style.fontSize = rem * ratio + 'px'
  }

  time = setTimeout(changeRem, 0)
})()
